<template>
  <b-field
    label="Time Range"
    class="input-field">
    <TimeRangeEditor
      v-model="inputs"
      :optional="true"
      :default-time-range="reportDefaultTimeRange"
      :default-time-range-name="reportDefaultTimeRange?.name || ''" />
  </b-field>
</template>

<script>
  import TimeRangeEditor from '@/components/reports/config/modules/common/TimeRangeEditor'

  export default {
    name: 'TitleTimeRange',
    components: {
      TimeRangeEditor,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      reportDefaultTimeRange: {
        type: Object,
        default: null,
      },
    },
    computed: {
      inputs: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
